import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export interface Language {
  code: string
  nameEn: string
  nameFr: string
  name: string
}

const fetchLanguages = async ({ pageParam = '1', lang, search }: FetchParams): Promise<PaginatedResponse<Language>> => {
  const params = new URLSearchParams()
  params.append('page', pageParam)
  if (lang) {
    params.append('lang', lang)
  }
  if (search) {
    params.append('search', search)
  }
  
  const { data } = await api.get<PaginatedResponse<Language>>(`/languages?${params.toString()}`)
  return data
}

export const usePaginateLanguages = ({ lang, search }: { lang?: 'en' | 'fr' | 'es', search?: string }) => {
  return usePaginate<Language>('languages', fetchLanguages, { lang, search })
}

